import { paymentReducer, watchPayment } from "./index";

export function getPaymentModule() {
  return {
    // Unique id of the module
    id: "paymentNew",
    // Maps the Store key to the reducer
    reducerMap: {
      paymentNew: paymentReducer,
    },
    // This module uses redux-saga middleware
    // This property will be be used by the SagaExtension
    // to run sagas for the moduleD
    sagas: [watchPayment],
  };
}
